<template>
  <div class="form">
    <AHeading :level="1">パスワード再設定</AHeading>
    <form class="form__container" @submit.prevent="passwordNew()">
      <ALabel for="email">メールアドレス</ALabel>
      <AInput
        class="form__input"
        type="text"
        name="email"
        :value="email"
        placeholder="onecareer@onecareer.jp"
        :validate-rule="emailValidateRule"
        validate-mode="blur"
        @input="handleInput"
        @validateBlur="handleValidateBlur"
      />
      <div class="form__button-wrapper">
        <AButton
          round
          fill
          bold
          size="medium"
          :disabled="buttonDisabled"
          :processing="processing"
          class="form__button"
          >パスワード再設定メール送信</AButton
        >
      </div>
    </form>
    <div v-for="(link, index) in links" :key="index" class="form__link">
      <ALink :to="link.to">{{ link.text }}</ALink>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import * as api from '@/api/index';
import AButton from '@/components/atoms/AButton/index.vue';
import AHeading from '@/components/atoms/ATypography/AHeading/index.vue';
import ALabel from '@/components/atoms/ATypography/ALabel/index.vue';
import AInput from '@/components/atoms/AForm/AInput/index.vue';
import ALink from '@/components/atoms/ATypography/ALink/index.vue';
import { emailValidateRule } from '@/helpers/validateRules';
import { ErrorEmailMessage } from '@/helpers/errorMessages';

export default defineComponent({
  name: 'PasswordNew',
  components: {
    AButton,
    AHeading,
    ALabel,
    AInput,
    ALink
  },
  data() {
    return {
      email: '',
      emailValidateRule: emailValidateRule,
      buttonDisabled: true,
      processing: false,
      links: [
        { to: '/users/sign_in', text: 'ログインはこちら >' },
        { to: '/users/sign_up', text: '新規登録はこちら >' }
      ]
    };
  },
  methods: {
    handleInput(value) {
      this.email = value;
    },
    handleValidateBlur(error) {
      this.buttonDisabled = error;
    },
    async passwordNew() {
      // ボタン非活性の場合は無効
      if (this.buttonDisabled) return false;

      try {
        this.processing = true;
        await api
          .post('/api/v1/password', {
            email: this.email
          })
          .finally(() => {
            this.processing = false;
          });
        this.$router.push('/users/password_wait');
      } catch (error) {
        alert(ErrorEmailMessage);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.form {
  @include formBase;

  &__link {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
